import { useUpdateVacancyModal } from "@/features/update-vacancy"
import { IJobOpening } from "@/shared/api/employment"
import { useAppDispatch } from "@/shared/lib/redux"
import { fetchVacancies } from "../../model"
import { FC } from "react"
import { DropdownItem } from "@/shared/ui/dropdown-item"
import SettingsSvg from '@/shared/assets/images/GearSix.svg'

interface EditVacancyFormProps {
    vacancy: IJobOpening
}

export const EditVacancyForm: FC<EditVacancyFormProps> = ({ vacancy }) => {
    const { openEditVacancyFormModal } = useUpdateVacancyModal()
    const dispatch = useAppDispatch()

    const onEdit = () => {
        dispatch(fetchVacancies())
    }

    return (
        <DropdownItem 
            onClick={() => openEditVacancyFormModal(vacancy, onEdit)}
            icon={SettingsSvg} 
            label={"Настроить анкету"}        
        />
    )
}